import React from 'react';
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
    {
        image: '../images/service/b1.png',
        title: 'applications that are simple, responsive, and progressive ',
        description: 'A well-designed UI applies to both the look and feel of the app as well as the actual functionality.'
    },
    {
        image: '../images/service/b2.png',
        title: 'Fast loading time',
        description: 'We develop Apps which are responsive and reliable in terms of speed.'
    },
    {
        image: '../images/service/b3.png',
        title: 'Secure and Scalable',
        description: 'Security is an app feature that shouldn’t be looked at as a benefit—it’s a necessity. ' +
            'We ensure that all apps that we develop are not vulnerable  '
    },
]
const ServiceNine = ({textAlign, cardStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ServiceList.map( (val , i) => (
                <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`card-box ${cardStyle} ${textAlign}`}>
                            <div className="inner">
                                <div className="image">
                                    <Link to="#service">
                                        <img src={`${val.image}`} alt="card Images" />
                                    </Link>
                                </div>
                                <div className="content">
                                    <h4 className="title mb--20"><Link to="#service" dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                    <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: val.description}}></p>
                                </div>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceNine;